"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _IconSVG = _interopRequireDefault(require("../components/IconSVG"));
var _excluded = ["size", "title", "ariaHidden"];
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var pathSizesToPaths = {
  "16": /*#__PURE__*/_react.default.createElement("path", {
    d: "M1.25 13.09h-1V4.06c0-.96.78-1.74 1.74-1.74h2.32v1H1.99c-.41 0-.74.33-.74.74v9.03ZM14.01 2.32h-2.32v1h2.32c.41 0 .74.33.74.74v10.02c0 .41-.33.74-.74.74H1.99c-.41 0-.74-.33-.74-.74h-1c0 .96.78 1.74 1.74 1.74h12.02c.96 0 1.74-.78 1.74-1.74V4.06c0-.96-.78-1.74-1.74-1.74Zm-2.49 5.65-.71-.71L8.5 9.57V.26h-1v9.31L5.19 7.26l-.71.71 3.51 3.51 3.51-3.51h.02Zm-6.98 5.58h6.94v-1H4.53v1h.01Z"
  }),
  "24": /*#__PURE__*/_react.default.createElement("path", {
    d: "M1.688 19.643H.563V6.098a2.434 2.434 0 0 1 2.43-2.43H6.48v1.125H2.993c-.72 0-1.305.585-1.305 1.305v13.545Zm19.32-15.968H17.52V4.8h3.488c.72 0 1.305.585 1.305 1.305V21.12c0 .72-.585 1.305-1.305 1.305H2.985c-.72 0-1.305-.585-1.305-1.305H.555a2.434 2.434 0 0 0 2.43 2.43h18.023a2.434 2.434 0 0 0 2.43-2.43V6.098a2.434 2.434 0 0 0-2.43-2.43v.007Zm-3.87 8.153-.795-.795-3.78 3.78V.405h-1.125v14.408l-3.78-3.78-.795.795L12 16.965l5.138-5.137Zm.067 7.185H6.803v1.125h10.402v-1.125Z"
  }),
  "32": /*#__PURE__*/_react.default.createElement("path", {
    d: "M2.25 26.19H.75V8.13c0-1.78 1.45-3.24 3.24-3.24h4.65v1.5H3.99c-.96 0-1.74.78-1.74 1.74v18.06ZM28.01 4.9h-4.65v1.5h4.65c.96 0 1.74.78 1.74 1.74v20.02c0 .96-.78 1.74-1.74 1.74H3.98c-.96 0-1.74-.78-1.74-1.74H.74c0 1.78 1.45 3.24 3.24 3.24h24.03c1.78 0 3.24-1.45 3.24-3.24V8.13c0-1.78-1.45-3.24-3.24-3.24v.01Zm-5.16 10.87-1.06-1.06-5.04 5.04V.54h-1.5v19.21l-5.04-5.04-1.06 1.06L16 22.62l6.85-6.85Zm.09 9.58H9.07v1.5h13.87v-1.5Z"
  }),
  "48": /*#__PURE__*/_react.default.createElement("path", {
    d: "M3.188 39.278H1.312V12.195A4.67 4.67 0 0 1 5.978 7.53h6.968v1.875H5.977a2.794 2.794 0 0 0-2.79 2.79v27.083ZM42.022 7.53h-6.967v1.875h6.968a2.794 2.794 0 0 1 2.79 2.79V42.24a2.794 2.794 0 0 1-2.79 2.79H5.977a2.794 2.794 0 0 1-2.79-2.79H1.313a4.67 4.67 0 0 0 4.665 4.665h36.044a4.67 4.67 0 0 0 4.666-4.665V12.195a4.67 4.67 0 0 0-4.666-4.665Zm-7.874 15.983-1.328-1.328-7.883 7.883V.81h-1.875v29.258l-7.882-7.883-1.328 1.328 10.14 10.147L34.14 23.513h.008Zm.262 14.692H13.598v1.875H34.41v-1.875Z"
  }),
  "64": /*#__PURE__*/_react.default.createElement("path", {
    d: "M4.25 52.37h-2.5V16.26c0-3.43 2.79-6.22 6.22-6.22h9.29v2.5H7.97c-2.05 0-3.72 1.67-3.72 3.72v36.11Zm51.78-42.33h-9.29v2.5h9.29c2.05 0 3.72 1.67 3.72 3.72v40.06c0 2.05-1.67 3.72-3.72 3.72H7.97c-2.05 0-3.72-1.67-3.72-3.72h-2.5c0 3.43 2.79 6.22 6.22 6.22h48.06c3.43 0 6.22-2.79 6.22-6.22V16.26c0-3.43-2.79-6.22-6.22-6.22Zm-10.5 21.31-1.77-1.77-10.51 10.51V1.08h-2.5v39.01L20.24 29.58l-1.77 1.77 13.52 13.53 13.53-13.53h.01Zm.35 19.59H18.13v2.5h27.75v-2.5Z"
  })
};
var pathSizesToViewBox = {
  "16": "0 0 16 16",
  "24": "0 0 24 24",
  "32": "0 0 32 32",
  "48": "0 0 48 48",
  "64": "0 0 64 64"
};
var sizesToPathSizes = {
  "16": "16",
  "24": "24",
  "32": "32",
  "48": "48",
  "64": "64"
};
var sizes = ['16', '24', '32', '48', '64'];
var IconSaveModern = function IconSaveModern(_ref) {
  var _ref$size = _ref.size,
    sizeProp = _ref$size === void 0 ? '32' : _ref$size,
    _ref$title = _ref.title,
    title = _ref$title === void 0 ? 'Save Modern' : _ref$title,
    _ref$ariaHidden = _ref.ariaHidden,
    ariaHidden = _ref$ariaHidden === void 0 ? false : _ref$ariaHidden,
    props = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  var size = sizes.indexOf(sizeProp) !== -1 ? sizeProp : '32';
  return /*#__PURE__*/_react.default.createElement(_IconSVG.default, (0, _extends2.default)({
    width: size,
    height: size,
    viewBox: pathSizesToViewBox[sizesToPathSizes[size]],
    xmlns: "http://www.w3.org/2000/svg",
    focusable: "false",
    role: "img",
    title: title,
    ariaHidden: ariaHidden
  }, props, {
    iconClass: "SaveModern"
  }), pathSizesToPaths[sizesToPathSizes[size]]);
};
IconSaveModern.sizes = [16, 24, 32, 48, 64];
IconSaveModern.propTypes = {
  /** Available sizes: 16, 24, 32, 48, 64. In most cases, the size will be a square (e.g., 32px X 32px), but height variances can occur. */
  size: _propTypes.default.oneOf(sizes),
  /** Similar to the 'alt' attribute on image tags, this is optional for custom tooltips and will default to the icon name if not overriden. */
  title: _propTypes.default.string,
  /** Hide icon from screen readers. */
  ariaHidden: _propTypes.default.bool,
  /** Optional custom class. */
  className: _propTypes.default.string
};
var _default = IconSaveModern;
exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@lmig/design-system-icons-react/_cjs/account-experience/SaveModern.js
// module id = 1845
// module chunks = 0